import Breadcrumbs from '@mui/material/Breadcrumbs';
import { styled } from '@mui/material/styles';

type Props = {
  widthLastList: string;
  isRemoveLastList: boolean;
};

export const BreadcrumbsStyle = styled(Breadcrumbs)<Props>(
  ({ theme, widthLastList, isRemoveLastList }) => `
  min-width: 200px;
  margin-left: -8px;
  li:last-child {
    * {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
  .MuiBreadcrumbs-li:not(:first-child) {
    max-width:45%;
    ${theme.breakpoints.down('lg')} {
      max-width: 80%;
    }
    ${theme.breakpoints.down('md')} {
      max-width: 116px;
    } 
  }
  ${theme.breakpoints.down('md')} {
    display: flex;
    width: 100%;
    overflow: hidden;
    .MuiBreadcrumbs-li:last-child {
      display: ${isRemoveLastList ? 'none' : 'flex'};
    }
    .MuiBreadcrumbs-separator:nth-last-child(2) {
      display: ${isRemoveLastList ? 'none' : 'flex'};
    }
  } 
  .MuiBreadcrumbs-li:first-child {
    margin-left: 8px;
  }
  .breadcrumb-link:first-child {
    min-width: 100%;
  }
  .breadcrumb-link {
    max-width: 100%;
    display: block;
    white-space: nowrap;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
    line-height: 1;
    padding: 0;
    border-radius: 4px;
  }
`,
);
